<template>
  <div id="gallery_wrapper">
    <div id="gallery">
      <template v-for="(item, i) in videos">
        <div
          v-if="item.type === 'youtube'"
          :id="`video_${i}`"
          :key="`video${i}`"
          :class="item.type"
          :data-type="item.type"
          :data-videoid="item.path"
          :data-title="item.title"
          :data-description="item.description"
        />
        <div
          v-else
          :id="`video_${i}`"
          :key="`video${i}`"
          :class="item.type"
          :data-type="item.type"
          :data-title="item.title"
          :data-description="item.description"
          :data-image="item.image"
          :data-thumb="item.thumb"
          :data-videoogv="item.videoogv"
          :data-videowebm="item.videowebm"
          :data-videomp4="item.videomp4"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "Gallery",
  props: ["videos"],
  // methods: {
  //   import_script(url) {
  //     let script = document.createElement("script");
  //     script.setAttribute('src', url);
  //     document.getElementById("gallery_wrapper").appendChild(script);
  //   }
  // },
  mounted() {
    // setTimeout(() => {
    //   this.import_script('/js/jQuery.js');
    //   setTimeout(() => {
    //     this.import_script('/js/unitegallery.min.js');
    //     setTimeout(() => {
    //       this.import_script('/js/ug-theme-video.js');
    //       setTimeout(() => {
    //         $("#gallery").unitegallery({
    //           gallery_theme: "video",
    //           theme_skin: "right-thumb",
    //           theme_autoplay: true,
    //         });
    //       }, 100);
    //     }, 100);
    //   }, 100);
    // }, 100);
    // $("#gallery").unitegallery({
    //   gallery_theme: "video",
    //   theme_skin: "right-thumb",
    //   theme_autoplay: true,
    // });
  }
};
</script>
<style src="../../public/unitegallery/css/unite-gallery.css"></style>
<style src="../../public/unitegallery/themes/video/skin-right-thumb.css"></style>
<style scoped lang="scss">
/*.ug-videoskin-right-thumb .ug-strip-panel { overflow-y: hidden }
.ug-gallery-wrapper .ug-thumbs-strip { overflow-y: auto }*/
.right {
  float: right;
  background: #9e001a;
}

.right a {
  color: #fff;
  padding: 5px 10px;
  line-height: 26px;
  display: block;
  text-decoration: none;
}
</style>